import { useAppSelector } from "../app";

// enable submit button on Close out form with RITMS
export function useCanSubmitCloseOutForm() {
  const { data } = useAppSelector((state) => state.userAccess);
  return data.userAccess.submit_closeout_request_ritms === "yes";
}
